/**
 * Created by Carsten Bühler
 * User: c.buehler on 11.03.2019
 * Copyright: xdot GmbH 2019
 */
import React from 'external/react';
import PropTypes from 'external/prop-types';

import { ButtonToolbar, Dropdown } from 'external/react-bootstrap';
import { DataUtil } from 'plugin/liferay-widgets-react-web';
import NamedListWebApi from '../webapi/NamedListWebApi';
import { FliwasCheckbox } from '../components/BasicFormComponents';
import Icon from './Icon';


class SaveToNamedListDropdown extends React.Component {

    constructor(props) {
        super(props);
    }

    isInList(item, list) {
        let i = DataUtil.asItem(item);
        return item && i && list.entries.filter(entry => item.className === entry.className && i.id === entry.classPK).length > 0;
    }

    onItemClick(dataItem, list) {
        if (this.isInList(dataItem, list)) {
            const entries = list.entries.filter(entry => !(entry.className === dataItem.className && entry.classPK === DataUtil.asItem(dataItem).id));
            NamedListWebApi.update({ ...list, entries });
        } else {
            const entries = [ ...list.entries ];
            entries.push({ className: dataItem.className, classPK: DataUtil.asItem(dataItem).id });
            NamedListWebApi.update({ ...list, entries });
        }
    }

    render() {
        const { namedLists, dataItem } = this.props;

        return (
                <Dropdown variant="default" className="position-static pull-right">
                    <Dropdown.Toggle variant="default">
                        <Icon name="playlist-plus"/>
                    </Dropdown.Toggle>

                    <Dropdown.Menu className={"pull-right"}>
                        <Dropdown.Header>Zu Liste hinzufügen</Dropdown.Header>
                        <Dropdown.Divider />
                        {
                            /*
                            https://inovum-dev.de/jira/browse/FLIWASTPA-883
                            don't set checkbox to readonly
                             */
                            DataUtil.asArray(namedLists).map((namedList, index) => {
                                return (
                                    <Dropdown.Item 
                                        key={"namedList" + index}
                                        onSelect={this.onItemClick.bind(this, dataItem, namedList)}
                                    >
                                        <FliwasCheckbox
                                            name={"namedListCheck" + index}
                                            label={namedList.title}
                                            checked={this.isInList(dataItem, namedList)}
                                            onChange={this.onItemClick.bind(this, dataItem, namedList)}
                                        />
                                    </Dropdown.Item>
                                );
                            })}
                    </Dropdown.Menu>
                </Dropdown>
        );
    }
}


SaveToNamedListDropdown.propTypes = {
    dataItem: PropTypes.object.isRequired,
    namedLists: PropTypes.object.isRequired
};

export default SaveToNamedListDropdown;







// WEBPACK FOOTER //
// ./js/components/SaveToNamedListDropdown.jsx